import React from "react";
import { Badge } from "react-bootstrap";
import { Truncate } from "../../lib/Truncate";
import { _t } from "../../app/i18n/i18n";

export const PreferenceTags = ({ preference, selected = [], handleClick }) => {
  return (
    <>
      <p className="text-center">
        {_t("Select your interests for")} {_t(preference.label)}:
      </p>
      <Truncate show={7} more={7}>
        {preference.tags.map((tag) => (
          <Tag key={tag} label={tag} isActive={selected.includes(tag)} onClick={() => handleClick(tag, preference)} />
        ))}
      </Truncate>
      <hr />
    </>
  );
};

export const Tag = ({ label, isActive, onClick }) => {
  return (
    <Badge
      pill
      key={label}
      onClick={onClick}
      className={"mx-1 px-2 my-1 border border-primary cursor-pointer " + (isActive ? "bg-primary" : "bg-none ")}
    >
      <h6 className="font-weight-normal m-0 p-0">{isNaN(label) ? _t(label) : label}</h6>
    </Badge>
  );
};
